export enum SampleGenerationType {
    automatic = 1,
    manual = 2,
    oneSample = 3,
}
